import appHelpers from 'app/app-helpers';
import DepsService from 'services/dependencies';

const DRAFT = 'DRAFT';
const CONTEXT = 'cms';

const widgetsFields2Object = (response) =>
  response.entries.map((entry) => {
    const fields = appHelpers.getFieldsFromEntry(entry);
    return {
      ...entry,
      fields,
    };
  });

const entriesTransformation = (locales, widgets) =>
  widgets.reduce((entries, widget) => {
    const data = {
      fields: appHelpers.setFieldsToEntry(widget.fields),
      id: widget.id,
      title: 'widget',
    };
    if (widget.attachments) {
      data.attachments = widget.attachments;
      // eslint-disable-next-line array-callback-return
      locales.map((locale) => {
        if (widget.attachments[locale.code] && !widget.attachments[locale.code][0].id) {
          data.attachments[locale.code] = [
            {
              name: widget.attachments[locale.code][0].name,
              content: widget.attachments[locale.code][0].fileSource.split(',')[1],
            },
          ];
        }
      });
    }
    return entries.concat(data);
  }, []);

const getWidgetsUrl = (showOnlyPublishedWidgets) => {
  if (showOnlyPublishedWidgets) return DepsService.rest.cms.widgets.first.url;
  return DepsService.rest.cms.widgets.second.url;
};

export const fetchWidgets = async ({ showOnlyPublishedWidgets, jurisdictionId }) => {
  const url = getWidgetsUrl(showOnlyPublishedWidgets);
  const queryParams = { locale: '*' };
  const urlParams = { jurisdictionId };

  const response = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
  const result = {
    draft: response.versionType === DRAFT,
    items: widgetsFields2Object(response),
  };
  return result;
};

export const downloadAttachment = (attachment) => {
  const { url } = DepsService.rest.cms.widgets.download;

  return appHelpers.downloadFile(CONTEXT, DepsService, url, attachment);
};

export const publishWidgets = async (secondHandApproval, jurisdictionId, locales, widgets) => {
  const url = getWidgetsUrl(false);
  const entries = entriesTransformation(locales, widgets);
  const queryParams = {
    entries,
  };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};

export const discardWidgetsChanges = async (jurisdictionId) => {
  const { url } = DepsService.rest.cms.widgets.discard;
  const queryParams = {};
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/widgets.api.js